import React from "react";
import { Box, Text } from "@showitinc/showit-wc";
import FontPreview from "../FontPreview";
import styles from "./DesignSettingsFont.module.css";

const ActiveFontsPanel = ({ fonts, designContext, removeFont, unsavedFonts }) => {
  const unsavedFontsList = fonts.filter((font) => unsavedFonts.includes(font.get("name")));
  const savedFontsList = fonts.filter((font) => !unsavedFonts.includes(font.get("name")));

  return (
    <div className={styles["active-fonts-wrapper"]}>
      <Box className={styles["font-section-subheading"]}>
        <Text variant="heading-1" variantStyle="strong">
          Active Fonts
        </Text>
      </Box>
      <div className={styles["active-fonts-list-panel"]}>
        {unsavedFonts
          .reverse()
          .map(
            (fontName) =>
              fonts.get(fontName) && (
                <FontPreview
                  key={fontName}
                  font={fonts.get(fontName)}
                  fontName={fonts.getIn([fontName, "family"])}
                  designContext={designContext}
                  onClickRemove={removeFont || null}
                  unsaved
                />
              )
          )}
        {savedFontsList
          .valueSeq()
          .sortBy((font) => font.get("family"))
          .map((font) => (
            <FontPreview
              key={font.get("name")}
              font={font}
              designContext={designContext}
              fontName={font.get("family")}
              onClickRemove={removeFont || null}
            />
          ))}
      </div>
    </div>
  );
};

export default ActiveFontsPanel;
